/**
 * The My Child trailer, shared by the home page and the film page so that going
 * live is one edit here.
 *
 * The trailer is the director's own cut: `Highlight final.mp4` (2:27, 4K), which
 * Kaniz Moradi built from her "Second Trailer" selection
 * (docs/film/my-child/production-notes.md). It replaces the 85-second trailer we
 * assembled on 2026-09-18.
 *
 * `youtubeId` stays null until the reel is uploaded. While it is null the facade
 * shows the "trailer coming" poster with a notify-me field, which is true and
 * temporary. Upload text and file: docs/film/my-child/trailer-upload.md.
 */
export const TRAILER: { youtubeId: string | null; poster: string } = {
  youtubeId: null,
  /** Frame 0:44 of the reel: the flower, no text, no person. */
  poster: "/art/film/trailer-poster.jpg",
};
